import React from 'react';
import Avatar from 'react-avatar';
import Text from '../Text.js';
import * as Theme from '../../theme/index.js';
import CardBlock from '../Cards/CardBlock.js';
import { styled } from '@mui/system';
import * as localizationMaps from '../../localization/maps.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as dates from "@simplybenefits/sb-dates";
const stateMap = {
  0: 'Setup',
  1: 'Commissions',
  2: 'Master Application',
  3: 'Pending Underwriting',
  4: 'Pending Underwriting',
  5: 'Plan Assignment',
  6: 'Request Approval',
  7: 'Under Review',
  8: 'Approved',
  9: 'Sold',
  10: 'Sold'
};
const CardBlockLeft = styled('div')(({
  theme
}) => ({
  display: 'flex',
  height: '100%',
  lineHeight: '30px',
  textAlign: 'left',
  verticalAlign: 'middle',
  alignItems: 'center',
  width: '70%',
  [theme.breakpoints.down('500')]: {
    width: 'unset'
  }
}));
const CardBlockRight = styled('div')(({
  theme
}) => ({
  display: 'inline',
  height: '100%',
  lineHeight: '30px',
  textAlign: 'right',
  verticalAlign: 'middle',
  width: '30%',
  [theme.breakpoints.down('500')]: {
    width: '100%'
  }
}));
const CardBlockTop = styled('div')(({
  theme
}) => ({
  borderBottom: `1px solid ${Theme.colors.lightGrey}`,
  display: 'flex',
  height: 'auto',
  minHeight: '65px',
  width: '100%',
  [theme.breakpoints.down('500')]: {
    flexWrap: 'wrap'
  }
}));
const CardBlockBottom = styled('div')(({
  theme
}) => ({
  display: 'flex',
  height: 'auto',
  minHeight: '20px',
  paddingTop: '5px',
  width: '100%',
  [theme.breakpoints.down('500')]: {
    justifyContent: 'space-between'
  }
}));

/**
 * 
 * @param {*} props 
 * @returns 
 */
const QuoteCard = props => {
  const {
    quote,
    whitelabel,
    link
  } = props;
  return /*#__PURE__*/React.createElement(CardBlock, {
    onClick: () => {
      window.location.href = link;
    }
  }, /*#__PURE__*/React.createElement(CardBlockTop, null, /*#__PURE__*/React.createElement(CardBlockLeft, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline',
      height: '100%',
      paddingRight: '20px',
      width: '60px'
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    name: quote.company,
    size: "50",
    textSizeRatio: 2.2,
    round: true,
    fgColor: whitelabel.name ? whitelabel.primaryColor : Theme.colors.skyBlue,
    color: whitelabel.name ? whitelabel.lightColor : Theme.colors.lightBlue
  })), /*#__PURE__*/React.createElement(Text, {
    large: true,
    display: "block"
  }, quote.company)), /*#__PURE__*/React.createElement(CardBlockRight, {
    style: {
      color: Number(quote.state) === 10 ? whitelabel.primaryColor || Theme.colors.skyBlue : 'black'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    align: "right",
    mediumLarge: true,
    display: "block"
  }, localizationMaps.fromEnglish("quoteStatuses", quote.status)), /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    align: "right",
    medium: true,
    display: "block"
  }, localizationMaps.fromEnglish("quoteStates", stateMap[quote.state])))), /*#__PURE__*/React.createElement(CardBlockBottom, null, /*#__PURE__*/React.createElement(CardBlockLeft, null), /*#__PURE__*/React.createElement(CardBlockRight, null, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    tiny: true,
    display: "inline"
  }, i18n.t(tokens.labels.advisor.updated), dates.formatDateForDisplay(quote.dateUpdated, 'lll', i18n.locale)))));
};
export default QuoteCard;